export function hasAnyAction(action: {[key: string]: boolean}): boolean {
  // eslint-disable-next-line
  for (let [_, value] of Object.entries(action)) {
    if (value) {
      return value;
    }
  }
  return false;
}
